// Single source of truth for every intentional legacy redirect.
//
// Retired SEO landing pages and Wix-era URLs that Google and external links
// still hold. App.tsx generates its Navigate routes from this map, and
// scripts/prerender-news.mjs reads the same JSON to emit static HTML whose
// canonical points at the destination page, so client-side redirects are
// consolidated by search engines instead of being treated as duplicates.
//
// Do not delete entries and do not change a source or destination path.
// Entry order matters: explicit /post overrides must come before the
// /post/:slug catch-all route, which App.tsx registers after this map.
import raw from "./legacyRedirects.json";

export const LEGACY_REDIRECTS: Record<string, string> = raw as Record<string, string>;

/** Path-only destination (hash stripped), for canonical URLs. */
export const legacyCanonicalPath = (pathname: string): string | null => {
  const dest = LEGACY_REDIRECTS[pathname];
  if (!dest) return null;
  const clean = dest.split("#")[0];
  return clean || "/";
};
